import React, { useEffect, useRef, useState } from "react";
import AutoComplete from "../../../components/common/autoComplete";
import Button from "../../../components/common/button";
import * as actions from "../actions";
import { connect } from "react-redux";
import "./search.css";
import { opdbGTM } from '../../../utils/pulseUtils';

const Search = ({
  sourceCitiesV2 = [],
  destCitiesV2 = [],
  getV2Cities,
  getUnReviewedOrders,
  source,
  destination,
  handleSource,
  handleDestination,
  handleCurrentPage,
}) => {
  const [filteredSourceCityList, setFilteredSourceCityList] = useState([]);
  const [filteredDestCityList, setFilteredDestCityList] = useState([]);
  const sourceRef = useRef();
  const destinationRef = useRef();

  useEffect(() => {
    if (sourceRef.current) {
      sourceRef.current.value = source;
    }
    if (destinationRef.current) {
      destinationRef.current.value = destination;
    }
  }, [source, destination]);

  useEffect(() => {
    if (sourceCitiesV2.length) {
      const filteredSourceCityList = getDisplayNames(sourceCitiesV2);
      setFilteredSourceCityList(filteredSourceCityList);
    }
    if (destCitiesV2.length) {
      const filteredDestCityList = getDisplayNames(destCitiesV2);
      setFilteredDestCityList(filteredDestCityList);
    }
  }, [sourceCitiesV2, destCitiesV2]);

  const getDisplayNames = (cityArray) => {
    if (!Array.isArray(cityArray)) {
      return [];
    }
    return cityArray.map((city) => (city && city.display_name ? city.display_name : null));
  };

  const onSourceItemSelect = (item) => {
    let sourceCity = sourceCitiesV2.find((city) => city.display_name === item);
    handleSource({
      name: item,
      city_id: sourceCity && sourceCity.city_id,
    });
  };

  const onDestinationItemSelect = (item) => {
    let destinationCity = destCitiesV2.find((city) => city.display_name === item);
    handleDestination({
      name: item,
      city_id: destinationCity && destinationCity.city_id,
    });
  };

  const clearSourceItemSelection = () => {
    handleSource({ name: "" });
  };

  const clearDestinationItemSelection = () => {
    handleDestination({ name: "" });
  };

  const renderElements = function (item, value) {
    return (
      <div className="cursor">
        <p className="cityStyle">{item}</p>
      </div>
    );
  };

  const onSearchClick = () => {
    let query = {
      pageNo: 1,
      limit: 1,
      paytm_src_id: source.city_id,
      paytm_dest_id: destination.city_id,
    };
    handleCurrentPage(1);

    if (!source && !destination) {
      alert("Kindly enter source or destination for filtering");
      return;
    }
    getUnReviewedOrders(query, false);
    opdbGTM.askReviewSearch(source.name, destination.name);
  };

  const onClearClick = () => {
    handleSource({ name: "" });
    handleDestination({ name: "" });
    if(!source.name && sourceRef.current) {
      sourceRef.current.state.value = '';
    }
    if(!destination.name && destinationRef.current) {
      destinationRef.current.state.value = '';
    }
    handleCurrentPage(1);
    setFilteredSourceCityList([]);
    setFilteredDestCityList([]);
    let query = {
      pageNo: 1,
      limit: 1,
    };
    getUnReviewedOrders(query, false);
  };

  const fetchCities = (value, fieldType) => {
    getV2Cities(value, fieldType);
  };

  const buttonStyle = {
    background: "#00B8F5",
    color: "#ffffff",
    width: "14rem",
    marginRight: "14px",
  };

  return (
    <div className="">
      <div className="search-header">Search by Service:</div>
      <div className="inputsRow">
        <div className="deal-padding-right deal-textfield">
          <AutoComplete
            name="source"
            openOnFocus={true}
            placeholder="Source"
            ref={sourceRef}
            onSelect={onSourceItemSelect}
            onClear={clearSourceItemSelection}
            defaultValue={source || ""}
            fieldName="source"
            onChange={fetchCities}
            renderElements={renderElements}
            listData={filteredSourceCityList}
          />
        </div>
        <div className="deal-textfield deal-padding-right">
          <AutoComplete
            name="destination"
            openOnFocus={true}
            placeholder="Destination"
            ref={destinationRef}
            onSelect={onDestinationItemSelect}
            onClear={clearDestinationItemSelection}
            defaultValue={destination || ""}
            fieldName="destination"
            onChange={fetchCities}
            renderElements={renderElements}
            listData={filteredDestCityList}
          />
        </div>
        <Button label="Search" onButtonClick={onSearchClick} styleObj={buttonStyle} />

        <Button label="Reset" onButtonClick={onClearClick} styleObj={{ width: "14rem" }} />
      </div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sourceCitiesV2: store.ratingsReducer.sourceCitiesV2,
  destCitiesV2: store.ratingsReducer.destCitiesV2,
});

const mapDispatchToProps = (dispatch) => ({
  ratingInformationList: (query, isNewQuery) =>
    dispatch(actions.ratingInformationList(query, isNewQuery)),
  getV2Cities: (query, fieldType) => dispatch(actions.getV2Cities(query, fieldType)),
});

Search.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(Search);